/**
 * 버전 정보
 * 프론트엔드 버전을 여기서 관리합니다.
 */
export const FRONTEND_VERSION = "1.1";
